const getters = {
    // 银行卡类型列表
    bankTypeData: (state) => {
        return state.bankTypeData;
    },
    // 车主认证信息
    verificationInfo: (state) => {
        return state.verificationInfo;
    },
    // 车主银行卡列表
    bankList: (state) => {
        return state.bankList;
    },
    // 车主默认银行卡信息
    bankInfo: (state, getters) => {
        return getters.verificationInfo.customerBankCard || {};
    },
    // 提现时当前选中银行卡，没有就取默认
    selectBank: (state, getters) => {
        return state.selectBank || getters.bankInfo;
    },
    // 最新提现状态
    lastStatus: (state) => {
        const moneyRecord = state.moneyRecord
        return moneyRecord && moneyRecord.length ? moneyRecord[0].withdrawStatusStr : '暂无记录';
    },
    // 新增的银行卡号
    newBankCardNumber: (state) => {
        return state.newBankCardNumber;
    }
}
export default getters